import { createAsyncThunk } from "@reduxjs/toolkit";
import http from "app/requests/axiosInstance";

// The manage-booking API: the booking token from the client's email is the only credential.
// The HTTP client rejects with the response itself, so the API's { error, code } is error.data.
const apiError = (error: any) => error?.data ?? error?.response?.data ?? { error: "Something went wrong" };

export const getAppointmentGroupByBookingToken = createAsyncThunk(
  "appointments/getAppointmentGroupByBookingTokenStatus",
  async ({ bookingToken }: { bookingToken: string }, thunkAPI) => {
    try {
      const { data } = await http.get(`/v1/public/bookings/${bookingToken}`);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(apiError(error));
    }
  }
);

export const cancelBookingByToken = createAsyncThunk(
  "appointments/cancelBookingByTokenStatus",
  async ({ bookingToken }: { bookingToken: string }, thunkAPI) => {
    try {
      const { data } = await http.post(`/v1/public/bookings/${bookingToken}/cancel`, {});
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(apiError(error));
    }
  }
);

// Moves the same booking to the new time(s), keeping its payments
export const rescheduleBookingByToken = createAsyncThunk(
  "appointments/rescheduleBookingByTokenStatus",
  async (
    { bookingToken, appointments }: { bookingToken: string; appointments: any[] },
    thunkAPI
  ) => {
    try {
      const { data } = await http.post(`/v1/public/bookings/${bookingToken}/reschedule`, { appointments });
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(apiError(error));
    }
  }
);
